<template lang="html">
    <span v-if="error" class="error text-danger">{{ error }}</span>
</template>

<script>
export default {
    props: {
        error: String,
    },
}
</script>
<style type="scss">
    .error {
        display: block;
    }
</style>